import React, { useState } from "react";
import Saudacao from "../../assets/saudacao.svg"
import {
  PageContainer,
  LoginCard,
  Logo,
  Title,
  SubTitle,
  Label,
  InputWrapper,
  Input,
  IconLeft,
  IconRight,
  ForgotPassword,
  LoginButton
} from "./styles";

import { FaUser, FaLock } from "react-icons/fa";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { toast } from "react-toastify";

export default function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  async function handleLogin() {
    try {
      const data = {
        email: email,
        senha: password
      };

      const response = await api.post('/api/auth/login', data);
      
      // Assumindo que a API retorna um token e/ou dados do usuário
      localStorage.setItem('token', response.data.token);
      
      navigate("/dash");
    } catch (error) {
      console.error("Erro no login:", error);
      // Aqui você pode usar o toast para mostrar uma mensagem de erro
      // toast.error("Falha no login. Verifique suas credenciais.");
      alert("Falha no login. Verifique suas credenciais.");
    }
  }

  return (
    <PageContainer>
      <LoginCard>

        <Logo src={Saudacao} alt="Mascote" />

        <Title>Login</Title>
        <SubTitle>Autentique-se para entrar no sistema</SubTitle>

        <Label>Usuário</Label>
        <InputWrapper>
          <IconLeft>
            <FaUser size={16} color="#9CA3AF" />
          </IconLeft>
          <Input 
            placeholder="Digite seu nome de usuário" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputWrapper>

        <Label id senha>Senha</Label>
        <InputWrapper>
          <IconLeft>
            <FaLock size={16} color="#9CA3AF" />
          </IconLeft>

          <Input
            type={showPassword ? "text" : "password"}
            placeholder="Digite sua senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <IconRight onClick={() => setShowPassword(!showPassword)} style={{ cursor: "pointer" }}>
            {showPassword
              ? <IoEyeOffOutline size={20} color="#9CA3AF" />
              : <IoEyeOutline size={20} color="#9CA3AF" />
            }
          </IconRight>
        </InputWrapper>

        <ForgotPassword>Esqueceu sua senha?</ForgotPassword>

        <LoginButton onClick={handleLogin}>
          Entrar
        </LoginButton>

      </LoginCard>
    </PageContainer>
  );
}